import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $app = $('#bvi-app');
    if (!$app.length) return;

    // Initial Currency & Culture Detection
    let activeCurrency = $app.data('currency') || 'UAH';

    const unitHours = $app.data('unit-hours') || 'год';
    const unitDays = $app.data('unit-days') || 'дн';
    const yearCellFormat = $app.data('year-cell-format') || '{0} р.';
    const textMoreCurrencies = $app.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $app.data('text-more-short') || 'Ще';

    const seriesEtfBaseName = $app.data('series-etf') || 'S&P 500 / ETF';
    const seriesCashBaseName = $app.data('series-cash-real') || 'Готівка (купівельна спроможність)';
    const seriesItemBaseName = $app.data('series-item') || 'Залишкова вартість речі';

    // Financial configs by currency
    const currencyConfigs = {
        UAH: {
            symbol: '₴',
            rates: {
                etf: 0.16,      // 16% long-term annualized
                bonds: 0.15,    // 15% military OVDP (tax-free)
                deposit: 0.095, // 9.5% net bank deposit
                inflation: 0.09 // 9% consumer inflation
            },
            seriesBondsName: 'Військові ОВДП (15%)',
            seriesDepositName: 'Депозит (9.5% чистими)',
            priceMax: 300000,
            priceStep: 1000,
            defaultPrice: 58000,
            defaultSalary: 35000,
            presets: {
                iphone: { price: 58000, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 98000, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 40000, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 18000, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 31000, maintenance: 350, category: 'electronics', rate: 30 },
                tuning: { price: 66000, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        USD: {
            symbol: '$',
            rates: {
                etf: 0.10,      // 10% S&P 500
                bonds: 0.045,   // 4.5% US Treasuries
                deposit: 0.035, // 3.5% Savings account
                inflation: 0.028 // 2.8% USD inflation
            },
            seriesBondsName: 'US Treasuries / Bonds (4.5%)',
            seriesDepositName: 'Savings Deposit (3.5%)',
            priceMax: 10000,
            priceStep: 50,
            defaultPrice: 1400,
            defaultSalary: 3500,
            presets: {
                iphone: { price: 1400, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 2400, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 1000, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 450, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 750, maintenance: 10, category: 'electronics', rate: 30 },
                tuning: { price: 1600, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        EUR: {
            symbol: '€',
            rates: {
                etf: 0.09,      // 9% MSCI World / S&P 500 (EUR)
                bonds: 0.035,   // 3.5% Eurozone Sovereign Bonds
                deposit: 0.025, // 2.5% EUR Fixed Deposit
                inflation: 0.025 // 2.5% EUR inflation
            },
            seriesBondsName: 'Eurozone Bonds (3.5%)',
            seriesDepositName: 'Bank Deposit (2.5%)',
            priceMax: 10000,
            priceStep: 50,
            defaultPrice: 1300,
            defaultSalary: 2800,
            presets: {
                iphone: { price: 1300, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 2200, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 900, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 400, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 700, maintenance: 10, category: 'electronics', rate: 30 },
                tuning: { price: 1500, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        PLN: {
            symbol: 'zł',
            rates: {
                etf: 0.11,      // 11% S&P 500 (PLN)
                bonds: 0.065,   // 6.5% Obligacje skarbowe (EDO/COI)
                deposit: 0.05,  // 5% Lokata bankowa
                inflation: 0.045 // 4.5% Inflacja PLN
            },
            seriesBondsName: 'Obligacje Skarbowe (6.5%)',
            seriesDepositName: 'Lokata bankowa (5%)',
            priceMax: 40000,
            priceStep: 200,
            defaultPrice: 6000,
            defaultSalary: 7000,
            presets: {
                iphone: { price: 6000, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 10000, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 4200, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 1900, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 3200, maintenance: 45, category: 'electronics', rate: 30 },
                tuning: { price: 6800, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        GBP: {
            symbol: '£',
            rates: {
                etf: 0.085,
                bonds: 0.042,
                deposit: 0.04,
                inflation: 0.026
            },
            seriesBondsName: 'UK Gilts (4.2%)',
            seriesDepositName: 'Cash ISA / Deposit (4.0%)',
            priceMax: 10000,
            priceStep: 50,
            defaultPrice: 1100,
            defaultSalary: 2600,
            presets: {
                iphone: { price: 1100, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 1900, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 800, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 350, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 550, maintenance: 8, category: 'electronics', rate: 30 },
                tuning: { price: 1300, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        CHF: {
            symbol: 'Fr.',
            rates: {
                etf: 0.065,
                bonds: 0.012,
                deposit: 0.01,
                inflation: 0.011
            },
            seriesBondsName: 'Swiss Confederation Bonds (1.2%)',
            seriesDepositName: 'Bank Deposit (1.0%)',
            priceMax: 12000,
            priceStep: 50,
            defaultPrice: 1200,
            defaultSalary: 5500,
            presets: {
                iphone: { price: 1200, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 2100, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 950, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 400, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 650, maintenance: 10, category: 'electronics', rate: 30 },
                tuning: { price: 1400, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        CAD: {
            symbol: 'C$',
            rates: {
                etf: 0.09,
                bonds: 0.038,
                deposit: 0.032,
                inflation: 0.025
            },
            seriesBondsName: 'Government of Canada Bonds (3.8%)',
            seriesDepositName: 'High-Interest Savings (3.2%)',
            priceMax: 15000,
            priceStep: 50,
            defaultPrice: 1800,
            defaultSalary: 4200,
            presets: {
                iphone: { price: 1800, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 3000, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 1300, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 550, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 900, maintenance: 12, category: 'electronics', rate: 30 },
                tuning: { price: 2100, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        },
        CZK: {
            symbol: 'Kč',
            rates: {
                etf: 0.10,
                bonds: 0.042,
                deposit: 0.038,
                inflation: 0.028
            },
            seriesBondsName: 'Státní dluhopisy (4.2%)',
            seriesDepositName: 'Spořicí účet (3.8%)',
            priceMax: 200000,
            priceStep: 1000,
            defaultPrice: 32000,
            defaultSalary: 45000,
            presets: {
                iphone: { price: 32000, maintenance: 0, category: 'electronics', rate: 30 },
                macbook: { price: 54000, maintenance: 0, category: 'computers', rate: 20 },
                coffee: { price: 22000, maintenance: 0, category: 'general', rate: 15 },
                shopping: { price: 9500, maintenance: 0, category: 'fashion', rate: 50 },
                ps5: { price: 16000, maintenance: 200, category: 'electronics', rate: 30 },
                tuning: { price: 36000, maintenance: 0, category: 'auto_parts', rate: 35 }
            }
        }
    };

    if (!currencyConfigs[activeCurrency]) {
        activeCurrency = 'UAH';
    }

    const categoryRates = {
        electronics: 30,
        computers: 20,
        fashion: 50,
        auto_parts: 35,
        general: 15
    };

    let cfg = currencyConfigs[activeCurrency];

    // State
    const state = {
        price: cfg.defaultPrice,
        depreciationRate: 30,
        category: 'electronics',
        horizonYears: 5,
        monthlySalary: cfg.defaultSalary,
        monthlyMaintenance: 0
    };

    let chartInstance = null;

    function formatMoney(num) {
        if (isNaN(num) || !isFinite(num)) num = 0;
        return `${Math.round(num).toLocaleString('uk-UA')} ${cfg.symbol}`;
    }

    function updateDepreciationUI(rate) {
        $('#bvi-deprec-range').val(rate);
        $('#bvi-deprec-badge').text(`${rate}% / ${yearCellFormat.replace('{0}', 1)}`);

        // Check if rate matches one of the category presets
        let matchedCat = 'custom';
        for (const [cat, catRate] of Object.entries(categoryRates)) {
            if (catRate === rate) {
                matchedCat = cat;
                break;
            }
        }
        $('#bvi-category-select').val(matchedCat);
        state.category = matchedCat;
        state.depreciationRate = rate;
    }

    function calculateDepreciation(initialPrice, annualRatePercent, years) {
        let currentVal = initialPrice;
        const timeline = [initialPrice];
        const rate = Math.max(0.01, Math.min(0.95, annualRatePercent / 100));

        for (let y = 1; y <= years; y++) {
            currentVal = currentVal * (1 - rate);
            const minFloor = state.category === 'fashion' ? 0 : initialPrice * 0.05;
            if (currentVal < minFloor) currentVal = minFloor;
            timeline.push(Math.round(currentVal));
        }
        return timeline;
    }

    function calculateCompound(initialAmount, monthlyAddition, annualRate, years) {
        const r = annualRate / 12;
        let capital = initialAmount;
        const timeline = [initialAmount];

        for (let y = 1; y <= years; y++) {
            for (let m = 1; m <= 12; m++) {
                capital = capital * (1 + r) + monthlyAddition;
            }
            timeline.push(Math.round(capital));
        }
        return timeline;
    }

    function calculateRealCash(initialAmount, annualInflation, years) {
        const timeline = [initialAmount];
        let currentPurchasingPower = initialAmount;
        for (let y = 1; y <= years; y++) {
            currentPurchasingPower = currentPurchasingPower / (1 + annualInflation);
            timeline.push(Math.round(currentPurchasingPower));
        }
        return timeline;
    }

    function calculateAndRender() {
        const initialPrice = Math.max(0, state.price);
        const maintenance = Math.max(0, state.monthlyMaintenance);
        const years = state.horizonYears;
        const rates = cfg.rates;

        // 1. Time / Life Hours Cost
        const salary = Math.max(1, state.monthlySalary);
        const hourlyWage = salary / 160; // 160 working hours/mo
        const totalWorkHours = Math.round(initialPrice / hourlyWage);
        const totalWorkDays = (totalWorkHours / 8).toFixed(1);

        $('#bvi-kpi-work-hours-val').text(`${totalWorkHours} ${unitHours}`);
        $('#bvi-kpi-work-days-sub').text(`${totalWorkDays} ${unitDays}`);

        // 2. Calculations
        const itemTimeline = calculateDepreciation(initialPrice, state.depreciationRate, years);
        const etfTimeline = calculateCompound(initialPrice, maintenance, rates.etf, years);
        const bondsTimeline = calculateCompound(initialPrice, maintenance, rates.bonds, years);
        const depositTimeline = calculateCompound(initialPrice, maintenance, rates.deposit, years);
        const cashRealTimeline = calculateRealCash(initialPrice, rates.inflation, years);

        const finalItemVal = itemTimeline[years];
        const finalEtfVal = etfTimeline[years];
        const netGap = finalEtfVal - finalItemVal;
        const effectiveRealPrice = initialPrice + (finalEtfVal - initialPrice);

        // 3. Update KPIs
        $('#bvi-kpi-net-loss-val').text(formatMoney(netGap));
        $('#bvi-kpi-real-price-val').text(formatMoney(effectiveRealPrice));
        $('#bvi-kpi-resale-val-val').text(formatMoney(finalItemVal));

        // 4. Update Detailed Timeline Table
        const $tbody = $('#bvi-timeline-tbody');
        $tbody.empty();

        const labels = ['0'];
        for (let y = 1; y <= years; y++) {
            labels.push(yearCellFormat.replace('{0}', y));

            const gap = etfTimeline[y] - itemTimeline[y];
            const rowHtml = `
                <tr>
                    <td class="fw-bold text-body">${yearCellFormat.replace('{0}', y)}</td>
                    <td class="text-danger fw-semibold text-end">${formatMoney(itemTimeline[y])}</td>
                    <td class="text-muted text-end d-none d-sm-table-cell">${formatMoney(cashRealTimeline[y])}</td>
                    <td class="text-body text-end d-none d-md-table-cell">${formatMoney(depositTimeline[y])}</td>
                    <td class="text-primary fw-semibold text-end">${formatMoney(bondsTimeline[y])}</td>
                    <td class="text-success fw-bold text-end">${formatMoney(etfTimeline[y])}</td>
                    <td class="text-end fw-bold text-danger">+${formatMoney(gap)}</td>
                </tr>
            `;
            $tbody.append(rowHtml);
        }

        // 5. Render ApexCharts Chart
        renderChart(labels, itemTimeline, cashRealTimeline, depositTimeline, bondsTimeline, etfTimeline);
    }

    function renderChart(labels, itemData, cashData, depositData, bondsData, etfData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';
        const chartElement = document.querySelector('#bvi-apex-chart');
        if (!chartElement) return;

        const series = [
            { name: `${seriesEtfBaseName} (${Math.round(cfg.rates.etf * 100)}%)`, data: etfData },
            { name: cfg.seriesBondsName, data: bondsData },
            { name: cfg.seriesDepositName, data: depositData },
            { name: seriesCashBaseName, data: cashData },
            { name: seriesItemBaseName, data: itemData }
        ];

        const options = {
            series: series,
            chart: {
                type: 'line',
                height: 350,
                toolbar: { show: false },
                animations: { enabled: true, speed: 450 }
            },
            colors: ['#34c38f', '#556ee6', '#50a5f1', '#f1b44c', '#f46a6a'],
            stroke: {
                width: [3.5, 2.5, 2, 2, 3],
                curve: 'smooth',
                dashArray: [0, 0, 0, 5, 0]
            },
            markers: {
                size: 3,
                hover: { size: 6 }
            },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: {
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + cfg.symbol;
                        if (val >= 1000) return Math.round(val / 1000) + 'K ' + cfg.symbol;
                        return Math.round(val) + ' ' + cfg.symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                theme: isDark ? 'dark' : 'light',
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'center',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartElement, options);
            chartInstance.render();
        }
    }

    // Event Bindings: Price
    $('#bvi-price-input').on('input change', function () {
        state.price = parseFloat($(this).val()) || 0;
        $('#bvi-price-range').val(state.price);
        calculateAndRender();
    });

    $('#bvi-price-range').on('input change', function () {
        state.price = parseFloat($(this).val()) || 0;
        $('#bvi-price-input').val(state.price);
        calculateAndRender();
    });

    // Event Bindings: Depreciation Slider & Category Dropdown
    $('#bvi-deprec-range').on('input change', function () {
        const rate = parseInt($(this).val(), 10) || 30;
        updateDepreciationUI(rate);
        calculateAndRender();
    });

    $('#bvi-category-select').on('change', function () {
        const cat = $(this).val();
        if (cat !== 'custom' && categoryRates[cat] !== undefined) {
            const rate = categoryRates[cat];
            updateDepreciationUI(rate);
        } else {
            state.category = 'custom';
        }
        calculateAndRender();
    });

    // Event Bindings: Horizon, Salary, Maintenance
    $('#bvi-horizon-select').on('change', function () {
        state.horizonYears = parseInt($(this).val(), 10) || 5;
        calculateAndRender();
    });

    $('#bvi-salary-input').on('input change', function () {
        state.monthlySalary = parseFloat($(this).val()) || 0;
        calculateAndRender();
    });

    $('#bvi-maintenance-input').on('input change', function () {
        state.monthlyMaintenance = parseFloat($(this).val()) || 0;
        calculateAndRender();
    });

    // Currency Switcher
    function switchCurrency(newCurrency, isDropdown) {
        if (!currencyConfigs[newCurrency] || newCurrency === activeCurrency) return;

        activeCurrency = newCurrency;
        cfg = currencyConfigs[activeCurrency];

        if (isDropdown) {
            $('#bvi-currency-tabs > button[data-currency]').removeClass('active');
            $('.bvi-currency-dropdown-item').removeClass('active');
            $(`.bvi-currency-dropdown-item[data-currency="${newCurrency}"]`).addClass('active');
            $('#bvi-more-currencies-dropdown').addClass('active');
            $('#bvi-active-custom-currency').text(`${cfg.symbol} ${newCurrency}`);
        } else {
            $('#bvi-currency-tabs > button[data-currency]').removeClass('active');
            $('.bvi-currency-dropdown-item').removeClass('active');
            $(`#bvi-currency-tabs > button[data-currency="${newCurrency}"]`).addClass('active');
            $('#bvi-more-currencies-dropdown').removeClass('active');
            $('#bvi-active-custom-currency').html(
                `<span class="d-none d-sm-inline">${textMoreCurrencies}</span><span class="d-sm-none">${textMoreShort}</span>`
            );
        }

        // Update symbol everywhere
        $('.bvi-currency-symbol').text(cfg.symbol);

        // Adjust price & salary to new currency
        state.price = cfg.defaultPrice;
        state.monthlySalary = cfg.defaultSalary;
        state.monthlyMaintenance = 0;

        $('#bvi-price-range').attr({
            min: cfg.symbol === '₴' ? 500 : 50,
            max: cfg.priceMax,
            step: cfg.priceStep
        }).val(state.price);

        $('#bvi-price-input').val(state.price);
        $('#bvi-salary-input').val(state.monthlySalary);
        $('#bvi-maintenance-input').val(0);

        calculateAndRender();
    }

    $(document).on('click', '#bvi-currency-tabs > button[data-currency]', function () {
        const newCurrency = $(this).data('currency');
        switchCurrency(newCurrency, false);
    });

    $(document).on('click', '.bvi-currency-dropdown-item', function () {
        const newCurrency = $(this).data('currency');
        switchCurrency(newCurrency, true);
    });

    // 1-Click Presets
    $('[data-bvi-preset]').on('click', function () {
        const presetKey = $(this).data('bvi-preset');
        const p = cfg.presets ? cfg.presets[presetKey] : null;
        if (!p) return;

        $('[data-bvi-preset]').removeClass('btn-primary text-white').addClass('btn-light text-body border');
        $(this).removeClass('btn-light text-body border').addClass('btn-primary text-white');

        state.price = p.price;
        state.monthlyMaintenance = p.maintenance;

        $('#bvi-price-input').val(state.price);
        $('#bvi-price-range').val(state.price);
        $('#bvi-maintenance-input').val(state.monthlyMaintenance);

        updateDepreciationUI(p.rate || categoryRates[p.category] || 30);
        calculateAndRender();
    });

    // Initial Run & Currency State Setup
    const isCustomInitial = !['UAH', 'USD', 'EUR', 'PLN'].includes(activeCurrency);
    if (isCustomInitial) {
        $('#bvi-more-currencies-dropdown').addClass('active');
        $('#bvi-active-custom-currency').text(`${cfg.symbol} ${activeCurrency}`);
        $(`.bvi-currency-dropdown-item[data-currency="${activeCurrency}"]`).addClass('active');
        $('#bvi-currency-tabs > button[data-currency]').removeClass('active');
    }

    // Setup initial ranges & symbols
    $('.bvi-currency-symbol').text(cfg.symbol);
    $('#bvi-price-range').attr({
        min: cfg.symbol === '₴' ? 500 : 50,
        max: cfg.priceMax,
        step: cfg.priceStep
    }).val(state.price);

    updateDepreciationUI(state.depreciationRate);
    calculateAndRender();
});
